import React from 'react';
import { useNavigation } from './NavigationProvider';
import { Modal } from '../core/design-system/components/Modal';
import SignIn from '../features/auth/pages/SignIn';
import SignUp from '../features/auth/pages/SignUp';
import './styles.css';

const AuthModals = () => {
  const { showSignIn, showSignUp, closeModals } = useNavigation();

  return (
    <>
      <Modal
        isOpen={showSignIn}
        onClose={closeModals}
        size="sm"
        className="auth-modal"
      >
        <SignIn />
      </Modal>

      <Modal
        isOpen={showSignUp}
        onClose={closeModals}
        size="sm"
        className="auth-modal"
      >
        <SignUp />
      </Modal>
    </>
  );
};

export default AuthModals;